var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import Papa from 'papaparse';
import * as Raven from 'raven-js';
import Card from 'antd/lib/card';
import 'antd/lib/card/style/index.css';
import message from 'antd/lib/message';
import 'antd/lib/message/style/index.css';
import FormFile from './FormFile';
import FormReview from './FormReview';
var FormAthleteCsv = (function (_super) {
    __extends(FormAthleteCsv, _super);
    function FormAthleteCsv(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFetching: false,
            fileList: [],
            validAthletes: [],
            errorAthletes: [],
        };
        _this.handleSelectCategory = _this.handleSelectCategory.bind(_this);
        _this.handleSelectFile = _this.handleSelectFile.bind(_this);
        _this.handleRemoveFile = _this.handleRemoveFile.bind(_this);
        _this.handleUploadFile = _this.handleUploadFile.bind(_this);
        _this.handleReadCsv = _this.handleReadCsv.bind(_this);
        _this.handleCsvData = _this.handleCsvData.bind(_this);
        _this.handleUpdateValidAthlete = _this.handleUpdateValidAthlete.bind(_this);
        _this.handleUpdateErrorAthlete = _this.handleUpdateErrorAthlete.bind(_this);
        _this.handleSubmitForm = _this.handleSubmitForm.bind(_this);
        return _this;
    }
    FormAthleteCsv.prototype.handleSelectCategory = function (categoryId) {
        var category = this.props.categories.find(function (c) { return c.id === categoryId; });
        var rounds = this.props.rounds
            .filter(function (r) { return !!category && r.categoryId === category.id; })
            .sort(function (a, b) { return a.index - b.index; });
        var round = rounds[0];
        if (!round) {
            message.error('Missing data. Please refresh page!');
        }
        var roundBib = this.props.roundBibs.find(function (r) { return !!round && r.roundId === round.id; });
        if (!roundBib) {
            message.error('Missing data. Please refresh page!');
        }
        this.setState({ category: category, round: round, roundBib: roundBib });
    };
    FormAthleteCsv.prototype.handleSelectFile = function (file) {
        this.setState({ fileList: [file] });
    };
    FormAthleteCsv.prototype.handleRemoveFile = function () {
        this.setState({ fileList: [] });
    };
    FormAthleteCsv.prototype.handleUploadFile = function () {
        if (this.state.fileList.length < 1) {
            message.error('Please select a file to upload.');
            return;
        }
        if (this.state.fileList.length > 1) {
            message.error('Multiple files selected. Only 1 is allowed.');
            return;
        }
        var reader = new FileReader();
        reader.onload = this.handleReadCsv;
        try {
            reader.readAsText(this.state.fileList[0]);
        }
        catch (err) {
            Raven.captureException(err);
            message.error(err.message);
        }
    };
    FormAthleteCsv.prototype.handleReadCsv = function (event) {
        var _this = this;
        var fileReader = event.target;
        if (fileReader === null) {
            message.error('FileReader cannot find the file selected for upload.');
            return;
        }
        var csvData = Papa.parse(fileReader.result, {
            header: true,
            skipEmptyLines: true,
        });
        var athleteData = csvData.data.map(function (c) { return ({
            eventId: _this.props.event.id,
            categoryId: null,
            roundId: null,
            teamId: null,
            teamName: (c['Team Name (For Team Categories)'] || '').trim(),
            bibNumber: (c['Bib Number'] || '').trim(),
            name: (c['Athlete Name'] || '').trim(),
            gender: (c['Gender (Optional)'] || '').trim(),
            affiliation: (c['Affiliation (Optional)'] || ''),
            countryCode: (c['Country Code (Optional)'] || '').trim(),
            countryState: (c['State (Optional)'] || '').trim(),
            email: (c['Email (Private, Optional)'] || '').trim(),
            identifier: (c['Identifier (Private, Optional)'] || '').trim(),
        }); });
        this.handleCsvData(athleteData);
    };
    FormAthleteCsv.prototype.handleCsvData = function (csvRows) {
        var _this = this;
        csvRows.sort(function (a, b) { return a.bibNumber - b.bibNumber; });
        var category = this.state.category;
        if (!category) {
            Raven.captureException(new Error('FormAthleteCsv: Did not find category'));
            message.error('Missing data: Please refresh page');
            return;
        }
        var round = this.state.round;
        if (!round) {
            Raven.captureException(new Error('FormAthleteCsv: Did not find round'));
            message.error('Missing data: Please refresh page');
            return;
        }
        var roundBib = this.state.roundBib;
        if (!roundBib) {
            Raven.captureException(new Error('FormAthleteCsv: Did not find roundBib'));
            message.error('Missing data: Please refresh page');
            return;
        }
        var bibTracker = typeof roundBib.tracker === 'string'
            ? JSON.parse(roundBib.tracker)
            : roundBib.tracker.slice();
        var athletes = csvRows.reduce(function (accumulator, row) {
            row.categoryId = category.id;
            row.roundId = round.id;
            if (category.isTeamCategory && row.teamName) {
                var team = _this.props.teams.find(function (t) { return t.categoryId === category.id && t.name === row.teamName; });
                row.teamId = team ? team.id : null;
            }
            row.bibNumber = Number(row.bibNumber);
            if (row.bibNumber &&
                row.bibNumber >= 1 &&
                row.bibNumber <= 999) {
                var isOccupied = bibTracker.indexOf(row.bibNumber) > -1;
                if (isOccupied) {
                    row.bibNumber = null;
                }
                else {
                    bibTracker.push(row.bibNumber);
                }
            }
            else {
                row.bibNumber = null;
            }
            if ((category.isTeamCategory && !row.teamName) ||
                !row.bibNumber ||
                !row.name) {
                accumulator.error.push(row);
            }
            else {
                accumulator.valid.push(row);
            }
            return accumulator;
        }, {
            valid: [],
            error: [],
        });
        this.setState({
            validAthletes: athletes.valid,
            errorAthletes: athletes.error,
        });
    };
    FormAthleteCsv.prototype.handleUpdateValidAthlete = function (data, index) {
        var athlete = __assign({}, this.state.validAthletes[index], data);
        this.setState({
            validAthletes: this.state.validAthletes.slice(0, index).concat([
                athlete
            ], this.state.validAthletes.slice(index + 1, this.state.validAthletes.length)),
        });
    };
    FormAthleteCsv.prototype.handleUpdateErrorAthlete = function (data, index) {
        var athlete = __assign({}, this.state.errorAthletes[index], data);
        this.setState({
            errorAthletes: this.state.errorAthletes.slice(0, index).concat([
                athlete
            ], this.state.errorAthletes.slice(index + 1, this.state.errorAthletes.length)),
        });
    };
    FormAthleteCsv.prototype.handleSubmitForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var hideMessage, category_1, round_1, athletes, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ isFetching: true });
                        hideMessage = message.loading("Please stay on this page. Adding " + this.state.validAthletes.length + " athletes...");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        category_1 = this.state.category;
                        round_1 = this.state.round;
                        if (!category_1 || !round_1) {
                            throw new Error('Category/Round was not selected!');
                        }
                        athletes = this.state.validAthletes.map(function (a) { return ({
                            eventId: a.eventId,
                            categoryId: category_1.id,
                            teamId: a.teamId,
                            teamName: a.teamName,
                            name: a.name,
                            gender: a.gender,
                            affiliation: a.affiliation,
                            countryCode: a.countryCode && a.countryCode.toLowerCase(),
                            countryState: a.countryState,
                            email: a.email,
                            identifier: a.identifier,
                            athleteScores: [{
                                    id: undefined,
                                    roundId: round_1.id,
                                    bibNumber: Number(a.bibNumber),
                                }],
                        }); });
                        if (!category_1.isTeamCategory) return [3, 3];
                        return [4, this.handleCreateTeams(category_1, athletes)];
                    case 2:
                        athletes = _a.sent();
                        _a.label = 3;
                    case 3: return [4, this.props.handleCreateAthlete(athletes)];
                    case 4:
                        _a.sent();
                        return [3, 6];
                    case 5:
                        err_1 = _a.sent();
                        Raven.captureException(err_1);
                        this.setState({ isFetching: false });
                        hideMessage();
                        message.error(err_1.message);
                        return [3, 6];
                    case 6:
                        this.props.navigateTo("/event/" + this.props.event.subdomain + "/athletes");
                        window.location.reload();
                        return [2];
                }
            });
        });
    };
    FormAthleteCsv.prototype.handleCreateTeams = function (category, athletes) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var teamNames, teams, teamResponse, createdTeams, nextAthletes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        teamNames = {};
                        athletes.forEach(function (a) {
                            if (!a.teamId) {
                                teamNames[a.teamName] = 0;
                            }
                        });
                        teams = Object.keys(teamNames).map(function (name) { return ({
                            name: name,
                            eventId: _this.props.event.id,
                            categoryId: category.id,
                        }); });
                        if (!teams.length) {
                            return [2, athletes];
                        }
                        return [4, this.props.handleCreateTeam(teams)];
                    case 1:
                        teamResponse = _a.sent();
                        createdTeams = teamResponse.value;
                        nextAthletes = athletes.map(function (a) {
                            if (!a.teamId) {
                                var team = createdTeams.find(function (t) { return t.name === a.teamName; });
                                a.teamId = team ? team.id : null;
                            }
                            return a;
                        });
                        return [2, nextAthletes];
                }
            });
        });
    };
    FormAthleteCsv.prototype.render = function () {
        var hasUploadedAthletes = this.state.validAthletes.length > 0 || this.state.errorAthletes.length > 0;
        return (React.createElement(Card, null, !hasUploadedAthletes
            ? (React.createElement(FormFile, { isFormValid: this.state.category && this.state.fileList.length === 1, categories: this.props.categories, fileList: this.state.fileList, handleSelectCategory: this.handleSelectCategory, handleSelectFile: this.handleSelectFile, handleRemoveFile: this.handleRemoveFile, handleUploadFile: this.handleUploadFile }))
            : this.state.category && this.state.round && this.state.roundBib
                ? (React.createElement(FormReview, { isDisabled: this.state.isFetching, category: this.state.category, validAthletes: this.state.validAthletes, errorAthletes: this.state.errorAthletes, handleCsvData: this.handleCsvData, handleUpdateValidAthlete: this.handleUpdateValidAthlete, handleUpdateErrorAthlete: this.handleUpdateErrorAthlete, handleSubmitForm: this.handleSubmitForm }))
                : React.createElement("div", null, "Error: Missing data. Please refresh the page and try again.")));
    };
    return FormAthleteCsv;
}(React.Component));
export default FormAthleteCsv;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormAthleteCsvPage/FormAthleteCsv.tsx
// module id = 1211
// module chunks = 0